import gql from 'graphql-tag';

export const PRODUCTS = gql`
    query(
        $categories: [QueryArgument],
        $vendor: [QueryArgument],
        $price: [QueryArgument],
        $limit: Int,
        $offset: Int
        $orderBy: String
        $search: String
    ) {
        count: productCount(
            categories: $categories,
            vendor: $vendor,
            defaultPrice: $price,
            search: $search,
        )

        products(
            categories: $categories,
            vendor: $vendor,
            defaultPrice: $price,
            limit: $limit,
            offset: $offset,
            orderBy: $orderBy,
            search: $search
        ) {
            id
            title
            uri
            defaultPrice
            availableForPurchase

            ... on clothing_Product {
                images(limit: 1) @transform(width: 400, height: 400) {
                    title
                    thumb: url
                    srcset(sizes: ["1x", "2x", "3x"])
                }
                vendor {
                    id
                    title
                }
            }

            ... on item_Product {
                images(limit: 1) @transform(width: 400, height: 400) {
                    title
                    thumb: url
                    srcset(sizes: ["1x", "2x", "3x"])
                }
                vendor {
                    id
                    title
                }
            }

            variants {
                id
                title
                price
                salePrice
                isAvailable
                isDefault
            }
        }
    }
`;
